const KB = 1024;
const SECOND = 1000;
const MINUTE_IN_SECONDS = 60;
const MINUTE = MINUTE_IN_SECONDS * SECOND;
const CHUNK_SIZE_MULTIPLIER = 256;
const DEFAULT_STREAM_MULTIPLIER = 2;
const AUTO_DIAL_INTERVAL_SECONDS = 10;
const KEEP_ALIVE_SECONDS = 20;
const PING_TIMEOUT_SECONDS = 90;
const INCOMING_STREAM_TIMEOUT_MINUTES = 3;
const OUTGOING_STREAM_TIMEOUT_MINUTES = 4;
const SEND_BLOCKS_TIMEOUT_MINUTES = 5;
const RECEIVE_BLOCKS_TIMEOUT_MINUTES = 6;
const STREAM_IDLE_TIMEOUT_MINUTES = 3;
const CONNECTION_THRESHOLD = 10;
const DIAL_TIMEOUT_SECONDS = 30;
const STATS_LOG_INTERVAL_SECONDS = 5;
// Infra-peer (HAP + message broker) keep-alive reconnection. libp2p 3.x reconnects only
// peers tagged `keep-alive`; nothing tags them by default. A short bounded retry cycle
// (~30s) keeps early attempts fast, then the app re-arms on `peer:reconnect-failure` for
// indefinite recovery. See docs/P2P_STACK_MANAGER.md.
const INFRA_RECONNECT_RETRIES = 4;
const INFRA_RECONNECT_INTERVAL_SECONDS = 2;
const INFRA_RECONNECT_BACKOFF_FACTOR = 2;
const INFRA_REARM_INTERVAL_SECONDS = 30;
const INFRA_KEEP_ALIVE_TAG_VALUE = 100;
const REANNOUNCE_DELAY_SECONDS = 3;
const SUBSCRIPTION_VERIFY_DELAY_SECONDS = 1;

export const CHUNK_SIZE = CHUNK_SIZE_MULTIPLIER * KB;

export const P2P_CONFIG = {
  network: {
    defaultBootstrap: [
      '/dns4/dev-p2p.hap-alpha.six3ro.net/tcp/443/wss/p2p/12D3KooWADcdhDiFp8PYP12wTgfN3VUu1XABvt2QU1DAJ9FPew4K',
    ],
    defaultSwarmKey: 'c2b1e8f7a9d4c3b6e5f8a1d2c3b4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2',
    maxConnections: 250,
    autoDial: true,
  },
  yamux: {
    maxInboundStreams: 256,
    maxOutboundStreams: 256,
    enableKeepAlive: true,
    keepAliveInterval: KEEP_ALIVE_SECONDS * SECOND,
    clientStreamWindowSize: CHUNK_SIZE,
    maxStreamWindowSize: CHUNK_SIZE * DEFAULT_STREAM_MULTIPLIER,
    initialStreamWindowSize: CHUNK_SIZE,
  },
  ping: {
    timeout: PING_TIMEOUT_SECONDS * SECOND,
  },
  bitswap: {
    protocolPrefix: '/ipfs/bitswap',
    maxInboundStreams: 8,
    maxOutboundStreams: 16,
    messageSendConcurrency: 4,
    sendBlocksConcurrency: 4,
    sendBlocksDebounce: 50,
    incomingStreamTimeout: INCOMING_STREAM_TIMEOUT_MINUTES * MINUTE,
    outgoingStreamTimeout: OUTGOING_STREAM_TIMEOUT_MINUTES * MINUTE,
    sendBlocksTimeout: SEND_BLOCKS_TIMEOUT_MINUTES * MINUTE,
    receiveBlocksTimeout: RECEIVE_BLOCKS_TIMEOUT_MINUTES * MINUTE,
    streamIdleTimeout: STREAM_IDLE_TIMEOUT_MINUTES * MINUTE,
  },
  connectionManager: {
    maxConnections: 250,
    maxPeerAddrsToDial: 100,
    inboundConnectionThreshold: CONNECTION_THRESHOLD,
    autoDialInterval: AUTO_DIAL_INTERVAL_SECONDS * SECOND,
    dialTimeout: DIAL_TIMEOUT_SECONDS * SECOND,
    reconnectRetries: INFRA_RECONNECT_RETRIES,
    reconnectRetryInterval: INFRA_RECONNECT_INTERVAL_SECONDS * SECOND,
    reconnectBackoffFactor: INFRA_RECONNECT_BACKOFF_FACTOR,
  },
  keepAlive: {
    tagValue: INFRA_KEEP_ALIVE_TAG_VALUE,
    rearmInterval: INFRA_REARM_INTERVAL_SECONDS * SECOND,
  },
  reannounce: {
    delay: REANNOUNCE_DELAY_SECONDS * SECOND,
    subscriptionVerifyDelay: SUBSCRIPTION_VERIFY_DELAY_SECONDS * SECOND,
  },
  logging: {
    statsLogInterval: STATS_LOG_INTERVAL_SECONDS * SECOND,
    namespace: {
      libp2p: 'six3ro:p2p:libp2p',
      helia: 'six3ro:p2p:helia',
    },
  },
};
